import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
} from '@angular/core';
import { NavigationExtras } from '@angular/router';
import {
  ITrackingAction,
  ITrackingObject,
} from '../../../tracking/tracking.data';
import { IIcon } from '../icon/icon.interface';

@Component({
  selector: 'app-router-link',
  templateUrl: 'router-link.component.html',
  styleUrls: ['router-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouterLinkComponent implements OnInit {
  @Input() type: string = '';
  @Input() label: string;
  @Input() hideLabel: boolean;
  @Input() route: string | string[];
  @Input() navigationExtras: NavigationExtras;
  @Input() disabled: boolean;
  @Input() icon: IIcon;
  @Input() e2eId: string;
  @Input() alignment: string = 'left'; // TODO: make into enum
  @Input() trackingObject: ITrackingObject;
  @Input() trackingAction: ITrackingAction;
  @Input() trackingAdditionalProperties: any;

  @Output() onRoute: EventEmitter<void> = new EventEmitter<void>();

  constructor(private _ngZone: NgZone) {}

  ngOnInit() {}

  onClick(evt: MouseEvent) {
    // fix for APPS-763
    // https://stackoverflow.com/questions/48341085/angular-change-detection-not-triggering-on-router-navigate
    this._ngZone.run(() => {
      if (this.disabled) {
        evt.preventDefault();
      } else {
        this.onRoute.emit();
      }
    });
  }
}
